import{styled as o}from"styled-components";const t=o.legend`
  font-size: 13px;
  font-weight: bold;
`;export{t as BaseLegend};
